import React, { useEffect, useState } from 'react'
import HeaderNonSrp from '../header/headerNonSrp'
import SubHeader from '../header/subHeader'
import Footer from '../footer/footer'
import Tickets from './Tickets'
import { GetRequest, getSearchParams, PostRequest, PostRequestFile } from '../pnrEnquiry/common/helper'
import Alert from '../pnrEnquiry/common/Alert'
import AccountLoader from '../manageAccount/accountLoader'
import { apiUrl } from '../common/constants'

const Feedback = () => {

    const [isGuest, setIsGuest] = useState(true);
    const srchPrm = getSearchParams();
    const [loader, setLoader] = useState(false);
    const [alert, setAlert] = useState({ show: false, msg: '' });
    const [tickets, setTickets] = useState(false);
    const [catData, setCatData] = useState(false);
    const [fullData, setFullData] = useState(false);
    const [readOnly, setReadOnly] = useState(false);

    const handleAlert = (msg = false) => {
        if (msg) {
            setAlert({ show: true, msg });
        } else {
            setAlert({ show: false, msg: '' })
        }
    }

    function filterByCategory(data, category) {
        return data.filter(item => item.Category === category);
    }

    function groupByCategory(data) {
        return data?.reduce((acc, item) => {
            if (!acc[item.Category]) {
                acc[item.Category] = [];
            }
            acc[item.Category].push(item);
            return acc;
        }, {});
    }

    const submitFeedback = async(pnrNo, payload) => {
        const data = {...payload,pnrNo}
        setLoader(true);
        return await PostRequestFile(`${apiUrl.submitFeedback}`, data)
        .then((res) => {
            setLoader(false);
            // console.info(res.error)
            try {
                const resp = JSON.parse(res)
                if (resp?.APIFeedbackRatingSubmitResult?.IsSuccess) {
                    // console.info(`succuess`)
                    return {success: true, tktNo: JSON.parse(resp.APIFeedbackRatingSubmitResult.Data)?.Table[0]?.FeedbackID || ""}
                } else if(resp?.APIFeedbackRatingSubmitResult?.ErrorMessage) {
                    // console.info(`error`)
                    setAlert({ show: true, msg:  resp.APIFeedbackRatingSubmitResult.ErrorMessage })
                    return {success: false, error: resp.APIFeedbackRatingSubmitResult.ErrorMessage}
                } else if(res?.error){
                    // console.info(`error..`)
                    setAlert({ show: true, msg:  res.error })
                    return {success: false, error: res.error}
                }
            } catch (error) {
                
            }
            setAlert({ show: true, msg: res?.error || "Something went wrong." })
            return {success: false, error: res?.error || "Something went wrong."}
        })
      .catch((err) => {
         setLoader(false);
         setAlert({ show: true, msg: "Something went wrong." })
         return {success: false, tktNo: "", error: "Something went wrong.."}  
      });
      
    }

    
    const getFdbkByPnr = (pnrNo="") => {
        if (pnrNo) {
            setLoader(true);
            let url = `${apiUrl.getFeedbackDetsByPnr}?pnrNo=${pnrNo}`;
            GetRequest(url).then(result => {
                setLoader(false);
                // result = resp;
                // console.info(result)
                if (result.Success &&  result.data 
                    && result.data?.APIBookingDetailsForFeedback2Result.IsSuccess 
                    && result.data.APIBookingDetailsForFeedback2Result?.Data
                ) {
                //    console.info(result.data.APIBookingDetailsForFeedback2Result?.Data)
                   const dataLocal = JSON.parse(result.data.APIBookingDetailsForFeedback2Result?.Data);
                   const categoryLblData = dataLocal.Table;
                   const CategoriesData = groupByCategory(categoryLblData);
                   setCatData(CategoriesData);
                   const PnrList = dataLocal.Table1;
                   setTickets(PnrList);
                   setFullData(dataLocal);
                   if( PnrList[0].FBStatus && PnrList.FBStatus != "Open" && PnrList.FeedbackTime !="" && dataLocal.Table2 && dataLocal.Table2[0]){
                    setReadOnly(true);
                   }
                } else if(result?.data && result.data?.APIBookingDetailsForFeedback2Result?.ErrorMessage) {
                    setAlert({ show: true, msg: result.data.APIBookingDetailsForFeedback2Result?.ErrorMessage })
                } else{
                    setAlert({ show: true, msg: "Something went wrong." })
                }
            }).catch((err) => {
                console.log("err", err);
                setLoader(false);
            })
        } else {
            setAlert({ show: true, msg: 'Please enter valid PNR no' })
        }
    }

    useEffect(()=>{
        setLoader(false);
        if(srchPrm?.pnrNo && srchPrm.pnrNo != "" && srchPrm.pnrNo.length > 0){
            getFdbkByPnr(srchPrm.pnrNo);
            // const tickets = [
            //     {
            //         source: 'Chikkamangaluru',
            //         destination: 'Bengaluru',
            //         departure: '18:15, Wed 08 Feb',
            //         arrival: '23:15, Wed 08 Feb',
            //         pnr: 'G9909339',
            //         serviceClass: 'AIRAVAT CLUB CLASS'
            //     }
            // ];
            // setTickets(tickets);
        // } else if(window.customerProfile.isLoggedIn){
            // setIsGuest(false)
            // const tickets = [
            //     {
            //         source: 'Chikkamangaluru',
            //         destination: 'Bengaluru',
            //         departure: '18:15, Wed 08 Feb',
            //         arrival: '23:15, Wed 08 Feb',
            //         pnr: 'G9909339',
            //         serviceClass: 'AIRAVAT CLUB CLASS'
            //     },
            //     // Add more ticket objects as needed
            //     {
            //         source: 'Mysuru',
            //         destination: 'Bengaluru',
            //         departure: '16:30, Thu 09 Feb',
            //         arrival: '21:00, Thu 09 Feb',
            //         pnr: 'G9912345',
            //         serviceClass: 'AIRAVAT GOLD CLASS'
            //     },
            //     {
            //         source: 'Hubballi',
            //         destination: 'Bengaluru',
            //         departure: '20:00, Fri 10 Feb',
            //         arrival: '02:30, Sat 11 Feb',
            //         pnr: 'G9923456',
            //         serviceClass: 'AIRAVAT CLUB CLASS'
            //     },
            // ];
            // setTickets(tickets);
        }else{
            window.location.href = "/feedback/submit";
        }
        /*  else if(!window.customerProfile.isLoggedIn){
            if(srchPrm?.pnrNo && srchPrm.pnrNo != "" && srchPrm.pnrNo.length > 0){
            }else{
                setAlert({ show: true, msg: 'Please enter valid PNR no' })
            }
        } */
    },[])

    return (
        <>
            {loader && <AccountLoader />}   
            <div>
                <HeaderNonSrp />
                <SubHeader />
                <div className="feedback-ticket">
                  
                {/* {!isGuest && tickets && tickets.length > 0 &&
                    tickets.map((ticket, index) => (
                        <Tickets
                            key={index}  // Use index or unique ID from data
                            source={ticket.FromCity}
                            destination={ticket.ToCity}
                            departure={ticket.PickupDate}
                            arrival={ticket.ArrivalTime}
                            pnr={ticket.BookingRefNo}
                            serviceClass={ticket.BusType}
                            supportingDoc={ticket.SupportingDoc}
                            isGuest = {false}
                            CategoriesData = {catData}
                            submitFeedback = {submitFeedback}
                        />
                    ))
                } */}
                { 
                // isGuest &&
                 tickets && tickets.length > 0 &&
                    <Tickets
                        key={`gust_fdbck`}  // Use index or unique ID from data
                        source={tickets[0].FromCity}
                        destination={tickets[0].ToCity}
                        departure={tickets[0].PickupDate}
                        arrival={tickets[0].ArrivalTime}
                        pnr={tickets[0].BookingRefNo}
                        serviceClass={tickets[0].BusType}
                        supportingDoc={tickets[0].SupportingDoc}
                        isGuest = {true}
                        CategoriesData = {catData}
                        RatingData = {fullData}
                        readOnly = {readOnly}
                        submitFeedback = {(data)=>{return submitFeedback(tickets[0].PNR, data)}}
                        getFdbkByPnr = {(data)=>{return sugetFdbkByPnrbmitFeedback(tickets[0].PNR)}}
                     />
                }
                </div>
                {
                    alert.show &&
                    <Alert msg={alert.msg} error={true} close={() => handleAlert()} />
                }
                <Footer />
            </div>
        </>
    )
}

export default Feedback
